export interface StraightMulticastInput {
  ClientData: string;
  Event: { Id: number; HasHandicap: boolean };
  Game: {
    Id: number;
    GameTypeId: number;
    SpecialOddsValue: string;
    IsInPlay: boolean;
    BetTypeAvailability: number;
    NumberOfStarters: number;
    PlaceOddsDivisor: number;
    IncludedPlaces: number;
  };
  League: { Id: number };
  Location: { Id: number };
  MaxSystem: number;
  PlacementSource: string;
  Results: [{ ResultId: number; Places: number[] }];
  Sport: { Id: number; SportHandle: string };
  TaxSettings: string;
}

export interface CombinationMulticastInput {
  ClientData: string;
  Event: { Id: number; HasHandicap: boolean };
  Game: {
    Id: number;
    GameTypeId: number;
    SpecialOddsValue: string;
    IsInPlay: boolean;
    BetTypeAvailability: number;
    NumberOfStarters: number;
    PlaceOddsDivisor: number;
    IncludedPlaces: number;
  };
  League: { Id: number };
  Location: { Id: number };
  Magnitude: number;
  MaxSystem: number;
  PlacementSource: string;
  ResultIds: number[];
  Sport: { Id: number; SportHandle: string };
  TaxSettings: string;
}
